import React from 'react';


export const StageCustody = function({ planData, updateData }) {

  return (

          <div className="space-y-6">
            <div className="p-4 bg-[#5A4E9E]/5 border border-[#5A4E9E]/20 rounded-xl space-y-3">
              <label className="block text-sm font-medium">Child Information</label>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs text-white/40 mb-1">Child's Full Name</label>
                  <input type="text"
                    value={(planData.children[0] || {}).name || ''}
                    onChange={function(e) { updateData('children', [Object.assign({}, planData.children[0] || {}, { name: e.target.value })]); }}
                    placeholder="Enter child's full name"
                    className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2 text-sm focus:outline-none focus:border-[#5A4E9E]/40"
                    data-testid="child-name" />
                </div>
                <div>
                  <label className="block text-xs text-white/40 mb-1">Date of Birth</label>
                  <input type="date"
                    value={(planData.children[0] || {}).dob || ''}
                    onChange={function(e) { updateData('children', [Object.assign({}, planData.children[0] || {}, { dob: e.target.value })]); }}
                    className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2 text-sm focus:outline-none focus:border-[#5A4E9E]/40"
                    data-testid="child-dob" />
                </div>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Physical Custody</label>
              <select
                value={planData.physicalCustody}
                onChange={(e) => updateData('physicalCustody', e.target.value)}
                className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2"
              >
                <option value="">Select arrangement</option>
                <option value="joint">Joint Physical Custody</option>
                <option value="sole-plaintiff">Sole to Plaintiff</option>
                <option value="sole-defendant">Sole to Defendant</option>
              </select>
            </div>

            {(planData.physicalCustody === 'sole-plaintiff' || planData.physicalCustody === 'sole-defendant') && (
              <div className="p-4 bg-[#EAB308]/5 border border-[#EAB308]/20 rounded-xl space-y-3" data-testid="supervised-visitation-prompt">
                <label className="block text-sm font-medium">Is supervised visitation being requested?</label>
                <div className="flex gap-3">
                  <button onClick={function() { updateData('supervisedVisitation', 'yes'); }}
                    className={'px-4 py-2 rounded-lg border text-sm font-medium transition-all ' + (planData.supervisedVisitation === 'yes' ? 'border-[#EAB308] bg-[#EAB308]/10 text-[#EAB308]' : 'border-white/10 text-white/50 hover:border-white/20')}
                    data-testid="supervised-yes">Yes</button>
                  <button onClick={function() { updateData('supervisedVisitation', 'no'); }}
                    className={'px-4 py-2 rounded-lg border text-sm font-medium transition-all ' + (planData.supervisedVisitation === 'no' ? 'border-[#5A4E9E] bg-[#5A4E9E]/10 text-[#5A4E9E]' : 'border-white/10 text-white/50 hover:border-white/20')}
                    data-testid="supervised-no">No</button>
                </div>
              </div>
            )}

            <div>
              <label className="block text-sm font-medium mb-2">Legal Custody (Decision Making)</label>
              <select
                onChange={(e) => updateData('legalCustody', e.target.value)}
                className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2"
              >
                <option value="">Select arrangement</option>
                <option value="joint">Joint Legal Custody</option>
                <option value="sole-plaintiff">Sole to Plaintiff</option>
                <option value="sole-defendant">Sole to Defendant</option>
              </select>
            </div>
          </div>
        
  );
};
